/* global G */
import { curry, type PlatformEvent } from 'lib/util'

/**
 * Toggles the loading indicators intended to be displayed while the application is scanning for
 * bluetooth devices.
 *
 * @param loading  whether to display the loading indicators
 * @param module      current module
 * @param component   component that triggered the event
 * @param event       triggered event
 */
const displayScanFeedback = async (
  loading: boolean,
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  const action = module[G.STATE][G.ACTION]
  const actionUI = action[G.UI]

  const { quickActions = [] } = actionUI || {}
  const pairAction = quickActions.find((quickAction: any) => quickAction.key === 'pair')

  if (pairAction) {
    pairAction.loading = loading

    await module[G.ADAPTER][G.UI].update(module)
  }
}

export default curry(displayScanFeedback)
